<template>
  <dashboard-main-layout>
    <div>
      <div style="background-color: white; display: flex; justify-content: space-between; align-items: center; padding: 5px;">
        <div style="display: flex; gap: 10px; align-items: center;">
          <div style="gap: 30px; margin-left: 30px;">
            <h1>{{$t("_parc_")}}</h1>
          </div>
          <div style="margin-left: 105px; margin-top: 10px; margin-bottom: -10px;">
            <v-select
              color="orange"
              v-model="choosesite"
              dense
              clearable
              outlined
              :label="$t('_selectionneur_de_sites_')"
              :items="itemsWithSelectAll"
              multiple
              style="min-width: 300px; max-width: 450px; height: 56px;"
              @blur="onSiteSelectorClose"
              @change="markManualClose"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ choosesite[0] }}</span>
                <span v-if="index === 1">
                  , (+{{ choosesite.length - 1 }} autres)
                </span>
              </template>
              <v-list-item slot="prepend-item" ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="choosesite.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-title> {{$t("_select_all_")}}</v-list-item-title>
              </v-list-item>
              <v-divider slot="prepend-item" class="mt-2" />
            </v-select>     
          </div>
        </div>
        <LoadingDialog v-if="loading" :is_loading=loading></LoadingDialog>
        <div style="display: flex; gap: 10px; align-items: center;">
          <div style="margin-right: 10px;">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  v-model="dateRange"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click="menu = true"
                ></v-combobox>
              </template>
              <v-date-picker
                v-model="tempDate" 
                scrollable
                :min="'2016-01-01'"
              >
                <v-spacer></v-spacer>
                <v-btn text style="font-size: bold;" @click="menu = false">Annuler</v-btn>
                <v-btn text color="primary" @click="refreshDates">Rafraichir</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <div style="display: flex;">
        <dashboardparc  :liste_dashboard="list_dashboard"/>
        <v-card style="flex: 1; margin-top: 10px; margin-left: 5px; margin-right: 10px;">
          <MapParc :selectsite="choosesite"  :liste_parc="list_parc.data"/>
        </v-card>
      </div>
      <div>
        <v-card style="flex: 1; margin-top: 10px; margin-left: 10px; margin-right: 10px; border-top: 10px; border-bottom: 0px; padding: 10px;">
          <div class="btn">
            <v-btn v-if="canSeeAlarms" @click="setChangeprint(0)">{{$t("_evolutions_")}}</v-btn>
            <v-btn v-if="canSeeAlarms" @click="setChangeprint(1)">{{$t("_evolutions_/_alarmes_")}}</v-btn>
            <v-btn v-if="canSeeAlarms" @click="setChangeprint(2)">{{$t("_alarmes_")}}</v-btn> 
          </div>
        </v-card>
        <div style="display: flex;">
          <v-card
            v-if="evolution == true || alarmesandevolution == true"
            :style="{ marginRight: evolution == true ? '10px' : '0', marginLeft: '10px' }"
            style="flex: 1; margin-left: 10px; border-radius: 0;">
              <EvolutionParc :selected_site_id="list_id" :change_size="alarmesandevolution"/>
          </v-card>
          <v-card
            v-if="(alarmes === true || alarmesandevolution === true) && canSeeAlarms"
            :style="{ marginLeft: alarmes == true ? '10px' : '0', marginRight: '10px' }"
            style="flex: 1; margin-right: 10px; border-radius: 0;">
              <AlarmsParc :liste_alarmes="list_alarms"/>
          </v-card>
        </div>
      </div>
      <div>
        <v-card style="margin-bottom: 10px; margin-left: 10px; margin-right: 10px; margin-top: -20px;">
          <InstallationsParc :selectsite="choosesite" :liste_parc="list_parc.data"/>
        </v-card>
      </div>
    </div>
  </dashboard-main-layout>
</template>

<script>
import DashboardMainLayout from "../../layouts/Dashboard/MainLayout";
import { mapGetters } from "vuex";
import dashboardparc from "./parc/dashboardparc";
import MapParc from "./parc/MapParc";
import InstallationsParc from "./parc/InstallationsParc";
import AlarmsParc from "./parc/AlarmsParc";
import EvolutionParc from "./parc/EvolutionParc";
import api from "@/api/api";
import LoadingDialog from "@/components/Utils/LoadingDialog";

export default {
  components: {
    DashboardMainLayout,
    dashboardparc,
    MapParc,
    InstallationsParc,
    AlarmsParc,
    EvolutionParc,
    LoadingDialog,
  },

  mounted() {
    this.setDefaultDateToYesterday();
    const savedChoosesite = JSON.parse(localStorage.getItem('choosesite'));
    this.choosesite = savedChoosesite ? savedChoosesite : this.takeitems();
    this.take_selected_id();    
    this.get_current_user();
      this.$nextTick(() => {
        if (this.canSeeAlarms) {
          this.setChangeprint(1); // Show both by default for admins/data-analysts
        } else {
          this.setChangeprint(0); // Or whatever default you want for regular users
        }
      });  
    const savedChangeprint = localStorage.getItem('changeprint');
    this.changeprint = savedChangeprint ? parseInt(savedChangeprint) : 2;
  },

  data() {
    return {
      userRole: '',
      loading: false,
      alarmes: false,
      evolution: false,
      alarmesandevolution: true,
      menu: false,
      tempDate: null,
      dateRange: "",
      isManualClose: true,
      count: 0,
      choosesite: [],
      changeprint: 1,
      list_parc: [],
      list_dashboard: {
        nb_de_site: 0,
        pr_clean_parc: 0,
        pr_clean_parc_evo: 0,
        ip_clean_parc: 0,
        ip_clean_parc_evo: 0,
        pc_totale: 0,
        disponibilite_parc: 11,
        disponibilite_parc_evo: 11,
        pertes_recouvrables: 11,
        pertes_vs_modele_energie: 11,
        pertes_vs_modele_energie_evo: 11,
        major_alarms: 2,
        minor_alarms: 5,
        without_alarms: 11,
      },
      list_id: [],
      list_alarms: [],
      compteur: 0,
    };
  },

  computed: {
    itemsWithSelectAll() {
      return this.takeitems();
    },
    ...mapGetters({
      cur_install_id: 'cur_install_id',
      installations: 'installations'
    }),
    choosesAllSites() {
      return this.choosesite.length === this.itemsWithSelectAll.length;
    },

    choosesSomeSites() {
      return this.choosesite.length > 0 && !this.choosesAllSites;
    },

    icon() {
      if (this.choosesAllSites) return 'mdi-close-box';
      if (this.choosesSomeSites) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    canSeeAlarms() {
    return ['admin', 'data-analyst'].includes(this.userRole);
  },
  },

  watch: {
    choosesite(newChoosesite) {
      localStorage.setItem('choosesite', JSON.stringify(newChoosesite));
      if (this.isManualClose) {
        this.take_selected_id();
      }
    },
    
    dateRange(newDate, oldDate) {
      if (newDate !== oldDate) {
        this.take_selected_id();
      }
    },
    '$route': {
        async handler() {          
          //this.refresHeader()
          await this.get_current_user()         
        },
        immediate: true,
      },
  },

  methods: {
    get_current_user(){      
      this.userRole = this.$store.state.authStore.role     
      this.setChangeprint(1)     
    }, 

    setDefaultDateToYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      this.dateRange = yesterday.toISOString().slice(0, 10);
    },

    markManualClose() {
      this.isManualClose = false;
    },

    onSiteSelectorClose() {
      this.isManualClose = true;
      this.take_selected_id();
    },

    takeitems() {
      let liste = [];
      const statusRoles = { 
          "Vérifications préliminaires": 1,
          "Analyse en cours": 1,        
          "Analyse disponible": 0,
          "Analyse bientôt indisponible": 0,
          "Analyse indisponible": 0,
        }
      this.installations.forEach(element => {
        if(statusRoles[element.status]===0){
        let cleanName = element.installation_name.trim();
        liste.push(cleanName);
        }
      });
      return liste;
    },

    toggle() {
      if (this.choosesAllSites) {
        this.choosesite = [];
      } else {
        this.choosesite = this.takeitems();
      }
    },

    async take_selected_id() {
      let elm = [];

      this.loading = false;
      this.choosesite.forEach(site => {
        this.installations.forEach(element => {
          if (site === element.installation_name) {
            elm.push(element.installation_id);
          }
        });
      });
      this.list_id = elm;

      if (this.compteur >= 2 && elm.length > 0) {
        const response = await api.getlistparc({ parc: elm, dates: this.dateRange });
        this.list_parc = response.data || [];
        this.list_dashboard = response.data.total || {};
        this.list_alarms = await api.getlistalarms({ alarms: elm, dates: this.dateRange });
      }
      this.compteur++;
      this.loading = false;
    },

    setChangeprint(value) {
      if (value === 0) {
        this.alarmes = false;
        this.evolution = true;
        this.alarmesandevolution = false;
      } else if (value === 1) {
        this.evolution = false;
        this.alarmesandevolution = true;
        this.alarmes = false;
      } else if (value === 2) {
        this.alarmes = true;
        this.evolution = false;
        this.alarmesandevolution = false;
      }
    },

    refreshDates() {
      this.dateRange = new Date(this.tempDate).toISOString().slice(0, 10);
      this.menu = false;
    },
  },
};
</script>

<style>
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}

.selected-btn {
  background-color: #FFC069 !important;
  color: black !important;
}
</style>
